import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MetadataText = styled.p`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;
